module.exports = __webpack_public_path__ + "static/media/moon.b88a9649.svg";